<style>

  #scroller {
    position: fixed;
    bottom: 24px;
    left: 24px;
    z-index: 10;
    border-radius: 4px;
    background: #3B4252;
    border-left: 1px solid #2E3440;
    border-right: 1px solid #2E3440;
    border-bottom: 1px solid #2E3440;
    color: #ECEFF4;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
    cursor: pointer;
    display: none;
  }

  #scroller .icon {
    fill: #ECEFF4;
    width: 16px;
  }

</style>

<div id="scroller" on:click={scrollTop}>
  <img src="icons/up.svg" class="icon" alt="up"/>
</div>

<script>
  function scrollTop() {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  window.onscroll = function () {
    const top = document.body.scrollTop + document.documentElement.scrollTop < 400;
    document.getElementById('scroller').style.display = top ? 'none' : 'block';
  };
</script>
